import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import benLogo from 'components/assets/img/ben_logo.svg';

import './ScreensUserShowcaseOnlyAccess.scss';

const ShowcaseOnlyAccess = React.lazy(
  () => import('components/User/ShowcaseOnlyAccess/ShowcaseOnlyAccess'),
);

const cbn = 'showcase-only-access-screen';

function ScreensUserShowcaseOnlyAccess() {
  return (
    <div className={`${cbn}__window`}>
      <DocumentTitle>Showcase Access Only</DocumentTitle>
      <div className={`${cbn}__container`}>
        <div className={`${cbn}__logo`}>
          <img src={benLogo} alt="BENlabs" />
        </div>
        <div className={`${cbn}__wrapper`}>
          <Suspense fallback={<UILoader />}>
            <ShowcaseOnlyAccess />
          </Suspense>
        </div>
      </div>
    </div>
  );
}

export default ScreensUserShowcaseOnlyAccess;
